var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsageAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6V7.5H19.9395L13.5 13.9395L10.2802 10.7198C10.1396 10.5791 9.94887 10.5002 9.75 10.5002C9.55113 10.5002 9.3604 10.5791 9.21975 10.7198L1.5 18.4395L2.5605 19.5L9.75 12.3105L12.9697 15.5303C13.1104 15.6709 13.3011 15.7498 13.5 15.7498C13.6989 15.7498 13.8896 15.6709 14.0303 15.5303L21 8.5605V13.5H22.5V6H15Z",
    fill: "#FFA00D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageAlert);
export default __webpack_public_path__ + "static/media/UsageAlert.7a30c06b298d5734899802f8b96f469f.svg";
export { ForwardRef as ReactComponent };